import { render, staticRenderFns } from "./portalMobile.vue?vue&type=template&id=45e12d56&"
import script from "./portalMobile.vue?vue&type=script&lang=js&"
export * from "./portalMobile.vue?vue&type=script&lang=js&"
import style0 from "./portalMobile.vue?vue&type=style&index=0&id=45e12d56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports